export const ACCOUNT_TYPE = {
    customer: 'Customer',
    reseller: 'Reseller',
};
